module.exports = __webpack_public_path__ + "img/54-l.4861f2cd.png";